import request from '../../untils/request';

// 电表查询
export function selectListElectric(data) {
  return request({
    url: '/meter/selectList',
    method: 'get',
    params: data,
  });
}
// 水表查询
export function selectListWater(data) {
  return request({
    url: '/waterMeter/selectList',
    method: 'get',
    params: data,
  });
}
// 电表手动拉闸
export function breakMeter(data) {
  return request({
    url: '/lessee/breakMeter',
    method: 'get',
    params:  data ,
  });
}
// 电表手动合闸
export function enableMeter(data) {
  return request({
    url: '/lessee/enableMeter',
    method: 'get',
    params:  data ,
  });
}
// 水表手动拉闸
export function breakWater(data) {
  return request({
    url: '/lessee/breakWater',
    method: 'get',
    params: data,
  });
}
// 水表手动合闸
export function enableWater(data) {
  return request({
    url: '/lessee/enableWater',
    method: 'get',
    params: data,
  });
}
// 区域
export function selectTreeList(data) {
  return request({
    url: '/sensorDistrict/selectTreeList',
    method: 'get',
    params: data,
  });
}
// 商户树形数据查询
export function selectLesseeTreeData() {
  return request({
    url: '/lessee/selectLesseeTreeData',
    method: 'get',
  });
}
// 查询超级管理员手机号
export function getAdminPhone() {
  return request({
    url: '/basicUser/getAdminPhone',
    method: 'get',
  });
}

// 查询pc端商户电表列表
export function selectListByLesseeId(data) {
  return request({
    url: '/meter/selectListByLesseeId',
    method: 'get',
    params: data,
  });
}
// 查询pc端商户水表列表
export function selectListByLesseeIdWater(data) {
  return request({
    url: '/waterMeter/selectListByLesseeId',
    method: 'get',
    params: data,
  });
}

// 获取短信验证码
export function getSmsVerifyCode(data) {
  return request({
    url: '/lesseeUser/getSmsVerifyCode',
    method: 'get',
    params: data,
  });
}

// 售电查询 
export function selectListMeterById(data) {
  return request({
    url: '/payOrder/selectList',
    method: 'get',
    params: data,
  });
}
// 售水查询
export function selectListWaterById(data) {
  return request({
    url: '/payOrderWater/selectList',
    method: 'get',
    params: data,
  });
}
// 电表拉合闸列表
export function selectListBreakAndEnable(data) {
  return request({
    url: '/meterBreakAndEnableRecord/selectList',
    method: 'get',
    params: data,
  });
}
// 水表拉合闸列表
export function selectListWaterBreakAndEnable(data) {
  return request({
    url: '/waterBreakAndEnableRecord/selectList',
    method: 'get',
    params: data,
  });
}


// 电表手动拉闸密码
export function breakMeterManByPassword (data) {
	return request({
		url: '/lessee/breakMeterManByPassword',
		method: 'get',
		params: data,
	});
}
// 电表手动合闸密码
export function enableMeterManByPassword (data) {
	return request({
		url: '/lessee/enableMeterManByPassword',
		method: 'get',
		params: data,
	});
}
// 水表手动拉闸密码
export function breakWaterManByPassword (data) {
	return request({
		url: '/lessee/breakWaterManByPassword',
		method: 'get',
		params: data,
	});
}
// 水表手动合闸密码
export function enableWaterManByPassword (data) {
	return request({
		url: '/lessee/enableWaterManByPassword',
		method: 'get',
		params: data,
	});
}